import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manhwa';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-xl font-heading font-bold text-primary-400">
                韩漫漫画网
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              免费韩国漫画在线阅读平台，提供韩漫大全无删减下拉式内容，完整呈现原版故事，画质优良，让您享受纯正阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">联系方式</h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                contact@bluefocugroup.cn
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-customer-service-2-line"></i>
                </span>
                在线客服：工作日 9:00-18:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 韩漫漫画网 - 版权所有。本站所有漫画资源均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">使用条款</a>
            <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}